import "./App.sass";
export default {
  props: {
    hideFilter: Number,
    categoryIds: Array,
    featureIds: Array
  }
};
